export const SCHEDULING_FIELD_CONTEXT_BASE = [
    "The User Request will contain a description of when the user wants to schedule an appointment",
    `Current date and time is <CurrentDateTime> use this to build relative time ranges based off User Request.`,
    `Always look for time ranges since today and make sure they are 60 minutes away from the current date and time`,
    `Add some padding to the time range to make it more likely that there are slots available`,
    "When the user asks for coarse grained time such as 'tomorrow' or 'next week', Give a few options",
    "Always try to give 4 options to the user, the first ones should be the best matching options, the rest should be alternatives if there are not enough options available that match the user's request.",
    // "When responding back with slots, make sure to always provide them in an ordered list using HTML tags <ol> and <li>.",
    // "Use the messageData field to pass the slot list of options to the user, in a key named 'selectOptions' which will be an array of objects with a label and a value property. Make sure you do not append this list as HTML to the message text.",
    "If there are no slots available, Give the user some alternatives in the times around",
    "Use the getAvailableSlots tool to get the available slots",
    "When calling getAvailableSlots, if you don't find any slots, Try to call the tool again with a wider time range that the user may like",
    "If the availability is very scarce in the time range that the user is requesting and around it, mention that and choose some of the slots that are available in that time range or around it",
    "Be very concise in the message, example: 'Couldn't find any slots, There are very few slots available, here are some alternatives'"
];
export const FIELD_TYPES = {
    "section": { label: "section",
        examples: ["Section 1", "Section 2"],
        shortDescription: "Visual hierarchy label",
        fieldContext: `A section is just an informative/visual hierarchy, it doesn't impact the fields nor contains nested data, use it only to know the visual hierarchy of the form and get the context of the fields bellow it. Do not group data by sections when producing the output.`
    },
    "text": {
        label: "text",
        shortDescription: `Plain text. e.g. "Hello world"`,
        examples: ["some text"],
        structuredExamples: [[]],
        parts: "string",
        fieldContext: "A valid text. If it's required it should not be empty."
    },
    "classification": {
        label: "classification",
        shortDescription: `One of the predefined classification values. e.g. "category-a"`,
        examples: ["option1"],
        structuredExamples: ["option1"],
        parts: "string",
        fieldContext: "Similar than options, but is not visible to the user, it's used to classify the user's response based on the rest of the form data"
    },
    "scheduling": {
        label: "scheduling",
        shortDescription: `An appointment slot. e.g. "Tomorrow at 2 PM"`,
        examples: ["Working hours Today/Tomorrow"],
        structuredExamples: [{ slotData: { start: "2025-01-01T00:00:00Z", end: "2025-01-01T00:00:00Z" }, eventId: "123",
                participants: { primaryParticipant: { email: "john.doe@example.com", name: "John Doe" } } }],
        parts: {
            "slotData": "{start: string, end: string}",
            "eventId": "string",
            "participants": "{primaryParticipant: {email: string, name: string}, guests?: {email: string, name: string}[]}"
        },
        fieldContext: [...SCHEDULING_FIELD_CONTEXT_BASE].map((item) => `- ${item}`).join("\n").concat(`
    - Use the messageData field to pass the slot list of options to the user, in a key named 'selectOptions' which will be an array of objects with a label and a value property. Make sure you do not append this list as HTML to the message text.
    - If the getAvailableSlots tool returns slots, you should ask the user to select a single slot from the list of slots. 
    - The user will select a slot, make sure the selected slot is from one of the provided slots by the getAvailableSlots tool. If the user selects a slot that is not in the list, you should ask the user to select a slot from the list.
    - Once the user selects a slot, you should ask for the participant details that will be participating in the meeting.
    - Even if you are able to infer the participant details from other parts of the form data, you need to ask the user to confirm them, make sure to present what you are inferring currently, they can also provide completely different details.
    - Make sure that we have the primary participant details, the guests details are optional, so it could simply be an empty array. But make sure to ask the user for the guest details.
    - Once we have a slot and the participant details, you should call the reserveSlot tool to reserve the slot.
    - Once the slot is reserved, you should set the slotData and eventId in the output.
    `)
    },
    "options": {
        label: "options",
        shortDescription: `One of the available choices. e.g. "Option A"`,
        examples: ["option1"],
        structuredExamples: ["option1"],
        parts: "string",
        fieldContext: "A valid option. One of the following: option1, option2, option3"
    },
    "multipleOptions": {
        label: "multiple options",
        shortDescription: `One or more of the available choices. e.g. "Option A, Option B"`,
        examples: ["option1, option2"],
        structuredExamples: [["option1", "option2"]],
        parts: "string[]",
        fieldContext: `
    - You can select multiple options from the list in the form config
    - User may provide a string with commas or space etc, don't be strict about the format, just get the items that make sense from the input.
    `
    },
    "yesno": {
        label: "yes/no",
        shortDescription: `A yes or no answer. e.g. "yes" or "no"`,
        examples: ["yes", "no", "y", "n", "true", "false"],
        structuredExamples: [true, false],
        parts: "boolean",
        fieldContext: "A valid yes/no answer. Possible values: Yes, No, Y, N"
    },
    "fullName": {
        label: "Full Name",
        shortDescription: `A first and last name. e.g. "John Doe"`,
        examples: ["John Doe"],
        structuredExamples: [{ firstName: "John", lastName: "Doe" }],
        parts: {
            "firstName": "string",
            "middleName": "string",
            "lastName": "string"
        },
        fieldContext: `
    - A valid full name where we can infer the first and last names.
    - Middle Name is optional, omit the field if it's not provided.
    - Users may provide 2 names (First Name and Last Name) or 3 names (First Name, Middle Name, Last Name)
    - "John Doe", "Doe John", "Maria, Perez" "First Name: Juan, Last Name: Gonzales" all of this are valid formats, be flexible with the format.
    - Use general knowledge about ethnicity, country etc to infer the first, middle and last names.
    - In general, if the user provides 2 names, one of them is the first name and the other is the last name.
    - If the first names and last name are ambiguous you should ask the user for clarification.
    - User your knowledge about common names, name ethnicities, origin, etc to infer the first, middle and last names.
    - Check the Valid Values in the Form Definition and be strict about them.
    - If the names seem highly uncommon or may have mistakes, ask the user to confirm like this "Please confirm your name"
    `
    },
    "email": {
        label: "email",
        shortDescription: `A valid email address. e.g. "john@example.com"`,
        examples: ["john.doe@email.com", "peter @ gmail,com"],
        structuredExamples: ["john.doe@email.com", "peter@gmail.com"],
        parts: "string",
        fieldContext: `
      - A valid looking email address. User could make small mistakes like using a dot instead of a comma, we can ignore those.
      - Do not ask for confirmation if the email is clear and unambiguous.
      - If the email contains small extra spaces or clear typos, just fix them without asking for confirmation.
      - If there seems to be a typo in the email with respect to the name that the user provided, you can ask the user mentioning the possible typo.
      - If the email domain looks like a common domain with a small typo, ask the user to confirm with options that fix the possible domain typo IE: 'abc@gimail' may be a typo for 'abc@gmail.com'
    `
    },
    "date": {
        label: "date",
        shortDescription: `A calendar date. e.g. "January 1, 2025" or "01/01/2025"`,
        examples: ["2022-01-01", "Christmas", "New Year's Day", "21 of December 97"],
        structuredExamples: [
            { day: 1, month: 1, year: 2022 },
            { day: 25, month: 12, year: 2025 },
            { day: 1, month: 1, year: 2026 },
            { day: 21, month: 12, year: 1997 }
        ],
        parts: {
            "day": "number",
            "month": "number",
            "year": "number"
        },
        fieldContext: `A valid date with the following parts: day, month, year.
      - The days may come as: 26 Sept, Sept 26, 26/09, 26/09/2022, 26/09/22 etc.
      - Examples of user Inputs: "September 1st, 2025", "26/09/2022", "26/09/22" etc.      
      - The user can provide relative dates like "today", "tomorrow", "yesterday", "Christmas", "New Year's Day" etc.
      - In those cases use your knowledge of the calendar to infer the date, if it's too uncertain ask the user to confirm.
      - Use <CurrentDateTime> to infer the date for relative dates like "today", "tomorrow", "yesterday", "this Christmas" etc
      ## Date Ambiguity:
      - Always check for data ambiguity and provide options when the data is ambgious, for example 01/02/2020 is ambiguous, it could be January 2nd, 2020 or February 1st, 2020
      - 01-02-2020 is ambiguous, it could be January 2nd, 2020 or February 1st, 2020 
      - Sep 15, 17 is ambiguous, it could be September 15th, 2017 or September 17th, 2015
    `
    },
    "address": {
        label: "address",
        shortDescription: `A street address. e.g. "123 Main St, New York, NY 10001"`,
        examples: ["123 Main St, New York, NY, 10001, USA"],
        structuredExamples: [{ addressLine1: "123 Main St", city: "New York", state: "NY", zip: "10001", country: "USA" }],
        parts: {
            "addressLine1": "string",
            "city": "string",
            "state": "string",
            "zip": "string",
            "country": "string"
        },
        fieldContext: `
- A valid address with the following parts: addressLine1, city, state, zip, country. Address Line 1 and city are required. State, zip, and country are optional. Use your location knowledge to validate the address.
- Do not skip any parts of the address information, put it in addressLine1 if it's related to the address, otherwise ask the user to confirm mentioning the parts that dont seem to be related to the address.
- We should be flexible with the format of the address, we don't need to validate the state if its clearly from
  state-cities like Berlin, Hamburg, New York, etc. In general country and state can be assumed if it's a well known city.
- Do not ask for confirmation if the address looks good enough and clear.
- The zip code will usually be a provided next or after the city, we don't need to be strict with the commas.
- Based on the country, adapt to the local format (e.g., UK addresses don't have states, Canadian postal codes are alphanumeric).
- Use your location knowledge to infer as much as possible from the address, if it's too uncertain ask the user to confirm.
- You should always try to infer the country, and state from the address if possible. If you infer you should ask for confirmation.
- If we specify below that you should assume certain country and state, give priority to that, no need to ask for confirmation.
- Try to fill addressLine1, city, state, zip, country with the best of your knowledge.
- Infer state and country whenever possible.
`
    },
    "phone": {
        label: "phone",
        shortDescription: `A phone number with country code, area code and number. e.g. "+1 415 555 1234"`,
        examples: ["+49 123 456 7890", "1 (317) 555-1212"],
        structuredExamples: [{ countryCode: "49", areaCode: "123", number: "456 7890" }, { countryCode: "1", areaCode: "317", number: "555-1212" }],
        parts: {
            "countryCode": "string",
            "areaCode": "string",
            "number": "string"
        },
        fieldContext: `
    - A valid international phone number, be flexible with the format, the number could be said as 49 123 456 7890, 491234567890, 49-123-456-7890, 49-123-456-7890, etc.
    - The country code and number are required. The area code is optional based on your real world knowledge about the supplied country code. All the required parts of the phone number should be provided by the user and should not be inferred.
    - The user can also provide the number without a leading +, in such cases if there is ambiguity, confirm with the user the right country code.
    - Please make sure to not add any extra characters to the user input.
    - Be flexible with the number formatting, if the number is clearly separated, you can infer the countryCode, areaCode, number with the best of your knowledge.
    - In case of ambiguity, ask the user to confirm the number formatting.
    - If the number is reasonably clear, do your best inference.
    - If the number is not reasonably clear, ask the user to confirm the country code.
    - Try to infer countryCode, areaCode, number with the best of your knowledge.
    - If the inference is not complete, infer to the best aproximation and ask the user to confirm or add the missing parts.
    - Example: "1 415-299-1133" to {"countryCode": "1", "areaCode": "415", "number": "299-1133"} (This should trigger a confirmation)
    - Example: "415-299-1133" to {"countryCode": "1", "areaCode": "415", "number": "299-1133"} (This should trigger a confirmation)
    - Example: "+1 415-299-1133" to {"countryCode": "1", "areaCode": "415", "number": "299-1133"}
    - Example: "+1 (415) 299-1133" to {"countryCode": "1", "areaCode": "415", "number": "299-1133"}
    - Example: "+1 415.299.1133" to {"countryCode": "1", "areaCode": "415", "number": "299-1133"}
    - Example: "+1 415-299-1133" to {"countryCode": "1", "areaCode": "415", "number": "299-1133"}
    - Example: "+1 415-299-1133" to {"countryCode": "1", "areaCode": "415", "number": "299-1133"}
    - Area code can be left out if it is not required in a given country:
    -- Example of country not requiring area code: "+91-1234567890" to {"countryCode": "91", "number": "1234567890"}
    -- Do not skip any parts of the phone number, if part of the number is not present in the "areaCode" field it should be added to the "number" field.
    `
    },
    "composedList": {
        label: "composedList",
        shortDescription: "A list of structured items.",
        examples: [""]
    },
    "composed": { label: "composed", shortDescription: "A structured value.", examples: [""] },
    "age": {
        label: "age",
        shortDescription: `An age in years. e.g. "25" or "twenty-five"`,
        examples: ["32", "thirty two"],
        structuredExamples: [32],
        parts: "number",
        fieldContext: `
    - Be flexible with the format, the age could be said as 32, thirty two, 32 years old, 32 years, etc.
    - Only ask for confirmation if the age is too ambiguous or doesn't make sense (I.E 1000 years old, or 2 years old depending on the contex of the form)
    `
    },
    "timeOfDay": {
        label: "time of day",
        shortDescription: `A time of day. e.g. "10:30 AM" or "14:00"`,
        examples: ["10:00 AM", "10:00", "10"],
        structuredExamples: [{ hour: 10, minute: 0 }],
        parts: {
            "hour": "number",
            "minute": "number"
        },
        fieldContext: `
    - Be flexible with the format, the time of day could be said as 10:00 AM, 10:00, 10, 10 AM, 10 PM, etc.
    - Only ask for confirmation if the time of day is too ambiguous or doesn't make sense
    `
    },
    "duration": {
        label: "duration",
        shortDescription: `A length of time. e.g. "1 hour 30 minutes" or "90 minutes"`,
        examples: ["1 hour", "1h", "1 hour and 30 minutes", "30 minutes"],
        structuredExamples: [{ duration: 1 }],
        parts: "number",
        fieldContext: `
    - The duration should always be converted to minutes.
    - Be flexible with the format, the duration could be said as 1 hour, 1h, 1 hour and 30 minutes, 30 minutes, 1 1/2 hours, 1.5 hours etc.
    - Only ask for confirmation if the duration is too ambiguous or doesn't make sense
    `
    },
    "number": {
        label: "number",
        shortDescription: `A numeric value. e.g. "42" or "3.14"`,
        examples: ["123", "one hundred twenty three", "123.45"],
        structuredExamples: [123, 123],
        parts: "number",
        fieldContext: `
    - Be flexible with the format, the number could be said as 123, one hundred twenty three, 123.45 etc.
    - Only ask for confirmation if the number is too ambiguous or doesn't make sense
    `
    },
    "integer": {
        label: "integer",
        shortDescription: `A whole number. e.g. "42"`,
        examples: ["123", "one hundred twenty nine"],
        structuredExamples: [123, 129],
        parts: "number",
        fieldContext: `
    - Be flexible with the format, the number could be said as 123, one hundred twenty three, 123.45 etc.
    - Only ask for confirmation if the number is too ambiguous or doesn't make sense
    `
    },
    // "money": {
    //   label: "money",
    //   examples: ["$123", "123 dollars"],
    //   structuredExamples: [{currency: "USD", amount: 123}],
    //   parts: {
    //      "currency": "string",
    //      "amount": "number"
    //     },
    //   fieldContext: `
    //   - Be flexible with the format, the money could be said as $123, 123 dollars, 123.45 dollars, 123.45 USD, etc.
    //   - Only ask for confirmation if the money is too ambiguous or doesn't make sense
    //   `
    // },
    "percentage": {
        label: "percentage",
        shortDescription: `A percentage value. e.g. "25%" or "fifty percent"`,
        examples: ["10%", "ten percent"],
        structuredExamples: [10],
        parts: "number",
        fieldContext: `
    - Be flexible with the format, the percentage could be said as 10%, ten percent, 10%, 10% of something, etc.
    - Only ask for confirmation if the percentage is too ambiguous or doesn't make sense
    `
    },
    "url": {
        label: "url",
        shortDescription: `A web address. e.g. "https://example.com"`,
        examples: ["https://www.google.com", "www.google.com"],
        structuredExamples: [{ protocol: "https", domain: "www.google.com", path: "", query: "" }],
        parts: {
            "protocol": "string",
            "domain": "string",
            "path": "string",
            "query": "string"
        },
        fieldContext: `
    -A valid URL. It could contain small mistakes, if it misses a protocol, you can assume https.
    -Ask for confirmation if the URL is from a well known website and it have some typo.
    `
    },
    "file": {
        label: "file",
        shortDescription: `A file attachment. e.g. "document.pdf"`,
        examples: ["file.pdf", "file.jpg", "file.png"],
        fieldContext: `
    -This is a structured field, you dont need to infer anything here, just return the same value that you receive.
    `,
        parts: {
            "fileName": "string",
            "fileType": "string",
            "fileUri": "string"
        },
    }
};
const { scheduling, composedList, composed, classification, ...EXPOSED_FIELD_TYPES } = FIELD_TYPES;
export { EXPOSED_FIELD_TYPES };
